module.exports = __webpack_public_path__ + "static/media/Legacy_Farms.c4361dfa.jpg";